import { render, staticRenderFns } from "./AttributeValueColors.vue?vue&type=template&id=1c8eda64"
import script from "./AttributeValueColors.vue?vue&type=script&lang=ts"
export * from "./AttributeValueColors.vue?vue&type=script&lang=ts"
import style0 from "./AttributeValueColors.vue?vue&type=style&index=0&id=1c8eda64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports